export default __webpack_public_path__ + "static/media/PeacockPage2.85b1d894.txt";